import { ADDRESS_BILLING_CATEGORY } from 'services/constants/cart';
import { DESTINATION_TYPES } from '../../../constants';
import type { BillingType, CartAddressData } from '../../../types';

/** Resolves the billing form type from a saved address category. */
export function getBillingType(address?: CartAddressData): BillingType {
  // PSI identifies company billing addresses by category; all other states use the private form.
  return address?.category === ADDRESS_BILLING_CATEGORY.COMPANY ? DESTINATION_TYPES.COMPANY : DESTINATION_TYPES.PRIVATE;
}
